import { Components, Theme } from '@mui/material';

export const createOutlinedInputStyles = (theme: Theme): Components['MuiOutlinedInput'] => ({
  styleOverrides: {
    root: {
      '& fieldset': {
        borderColor: theme.palette.divider,
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.primary.main,
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.primary.main,
      },
      backgroundColor: theme.palette.background.paper,
    },
    input: {
      color: theme.palette.text.primary,
    },
  },
});

export const createRusticOutlinedInputStyles = (theme: Theme): Components['MuiOutlinedInput'] => ({
  styleOverrides: {
    root: {
      '& fieldset': {
        borderColor: 'rgba(183, 149, 118, 0.5)',
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#bf6a2d',
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#bf6a2d',
      },
      backgroundColor: 'rgba(255, 250, 242, 0.7)',
    },
    input: {
      color: '#3a2d21',
    },
  },
});

export const createInputLabelStyles = (theme: Theme): Components['MuiInputLabel'] => ({
  styleOverrides: {
    root: {
      color: theme.palette.text.secondary,
      '&.Mui-focused': {
        color: theme.palette.primary.main,
      },
    },
  },
});

export const createRusticInputLabelStyles = (theme: Theme): Components['MuiInputLabel'] => ({
  styleOverrides: {
    root: {
      color: '#755523',
      '&.Mui-focused': {
        color: '#bf6a2d',
      },
    },
  },
});

export const createFormHelperTextStyles = (theme: Theme): Components['MuiFormHelperText'] => ({
  styleOverrides: {
    root: {
      color: theme.palette.text.secondary,
    },
  },
});

export const createRusticFormHelperTextStyles = (theme: Theme): Components['MuiFormHelperText'] => ({
  styleOverrides: {
    root: {
      color: '#755523',
    },
  },
}); 